/**
 * Directive to handle image loading errors and display a fallback image
 */
export const fallbackImage = {
  mounted(el: HTMLImageElement, binding: any) {
    const fallbackSrc = binding.value || '/assets/default-avatar.png';
    
    // Save original src for potential re-tries
    if (!el.dataset.originalSrc) {
      el.dataset.originalSrc = el.src;
    }
    
    // Create a flag to prevent infinite loops
    el.dataset.usedFallback = 'false';
    
    // Handle error event
    const handleError = () => {
      // Only set fallback if we haven't already used it
      if (el.dataset.usedFallback === 'false' && el.src !== fallbackSrc) {
        el.dataset.usedFallback = 'true';
        el.src = fallbackSrc;
        el.classList.add('fallback-image');
      }
    };
    
    // Remove old event listener if exists
    el.removeEventListener('error', handleError);
    
    // Add new event listener
    el.addEventListener('error', handleError);
    
    // If image is already broken and we haven't used fallback yet, apply it
    if (el.dataset.usedFallback === 'false' && (!el.complete || el.naturalHeight === 0)) {
      handleError();
    }
  },
  
  // Update when binding value changes
  updated(el: HTMLImageElement, binding: any) {
    // If binding value (fallback image) changes, update it
    const fallbackSrc = binding.value || '/assets/default-avatar.png';
    const originalSrc = el.dataset.originalSrc;
    
    // Reset the element if src has changed to something other than fallback
    if (el.src !== fallbackSrc && el.src !== originalSrc) {
      el.dataset.originalSrc = el.src;
      el.dataset.usedFallback = 'false';
      el.classList.remove('fallback-image');
    }
    
    // If image is currently a fallback, update the fallback image
    if (el.dataset.usedFallback === 'true' && el.classList.contains('fallback-image')) {
      el.src = fallbackSrc;
    }
  }
};
